import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { EnvironmentConfig, ENV_CONFIG } from 'src/app/core/enviroment-config';
import { CrudApiService } from 'src/app/core/service/abstract/rest-api.service';
import { DevicesStates } from 'src/app/data/model/devices-states';
import { ApiModule } from '../api.module';

@Injectable({
  providedIn: ApiModule
})
export class DeviceStatusMapApiService extends CrudApiService<DevicesStates> {
  constructor(http: HttpClient, @Inject(ENV_CONFIG) config: EnvironmentConfig) {
    super('data/telemetries/device-status-map', http, config);
  }
}
